import { render, staticRenderFns } from "./bet-board-actions.vue?vue&type=template&id=58b27cde&scoped=true"
import script from "./bet-board-actions.vue?vue&type=script&lang=js"
export * from "./bet-board-actions.vue?vue&type=script&lang=js"
import style0 from "./bet-board-actions.vue?vue&type=style&index=0&id=58b27cde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b27cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b27cde')) {
      api.createRecord('58b27cde', component.options)
    } else {
      api.reload('58b27cde', component.options)
    }
    module.hot.accept("./bet-board-actions.vue?vue&type=template&id=58b27cde&scoped=true", function () {
      api.rerender('58b27cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-board-actions.vue"
export default component.exports